// import { CustomSceneTransitionConfig } from './app-routing';
// import { BaseBootConfig } from '@scarybeasties/phaser-framework-core';
import { BaseApp } from '@scarybeasties/phaser-framework-core';
import { AppPlugin } from './AppPlugin';
import { GameDataHandler } from './game/GameDataHandler';
import { defaultBootConfig, defaultGameConfig, defaultScaleConfig } from './settings';

export class App extends BaseApp {

  musicMutedState:boolean = false;
  sfxMutedState:boolean = false;

  public override injectPlugin(game: Phaser.Game): void {
    game.plugins.install('app', AppPlugin, true, 'app', this);

    this.game?.events.addListener(Phaser.Core.Events.HIDDEN, this.onHidden,this);
    this.game?.events.addListener(Phaser.Core.Events.VISIBLE, this.onVisible,this);
  }

  onHidden()
  {
    this.musicMutedState = this.audioHandler.getChannelMute('music');
    this.sfxMutedState = this.audioHandler.getChannelMute('sfx');
    this.audioHandler.setChannelMute('music',true);
    this.audioHandler.setChannelMute('sfx',true);
  }

  onVisible()
  {
    this.audioHandler.setChannelMute('music',this.musicMutedState);
    this.audioHandler.setChannelMute('sfx',this.sfxMutedState);
  }

  // protected override buildQueryOverrideSceneData(config: CustomSceneTransitionConfig, targetScene: string): CustomSceneTransitionConfig {
  //   config.target = targetScene;
  //   config.data.gameSceneData = Object.assign({}, config.data.gameSceneData, this.queryTargetData?.gameSceneData, this.queryTargetData?.gsd);
  //   config.data.runSettings = Object.assign({}, config.data.runSettings, this.queryTargetData?.runSettings, this.queryTargetData?.rs);

  //   return config;
  // }
}

// export const app: App = (() => {
//   const app = new App(bootConfig, gameConfig, scaleConfig);
//   const gameDataHandler = new GameDataHandler(app);
//   app.init(gameDataHandler);

//   return app;
// })();
